import ClearModal from './ClearModal';
import DeleteModal from './DeleteModal';

export { DeleteModal };

export default ClearModal;
